var exports = {
  "kJ": "GiftEmbed.module__iconCircle___Z3E3Rn",
  "SP": "GiftEmbed.module__iconCircleActive___Z3E3Rn",
  "PP": "GiftEmbed.module__iconCircleInactive___Z3E3Rn",
  "_O": "GiftEmbed.module__iconCircleDisabled___Z3E3Rn",
  "Kk": "GiftEmbed.module__icon___Z3E3Rn",
  "m5": "GiftEmbed.module__iconError___Z3E3Rn",
  "DD": "GiftEmbed.module__title___Z3E3Rn",
  "jn": "GiftEmbed.module__titlePrimary___Z3E3Rn",
  "xP": "GiftEmbed.module__titleTertiary___Z3E3Rn",
  "S3": "GiftEmbed.module__titleDanger___Z3E3Rn",
  "xF": "GiftEmbed.module__subRow___Z3E3Rn",
  "Cz": "GiftEmbed.module__helpRow___Z3E3Rn",
  "U6": "GiftEmbed.module__pulse___Z3E3Rn",
  "mj": "GiftEmbed.module__skeletonCircle___Z3E3Rn",
  "Iz": "GiftEmbed.module__skeletonTitle___Z3E3Rn",
  "hI": "GiftEmbed.module__skeletonHelp___Z3E3Rn",
  "G3": "GiftEmbed.module__skeletonButton___Z3E3Rn",
};

module.exports = exports;
